import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { usersLoader } from './users-loader';

export const usersRoutes: RouteObject = {
  loader: usersLoader,
  children: [
    {
      path: '/users/list',
      lazy: lazyComponent(() => import('@pages/client/user/users-page'), 'UsersPage'),
    },
    {
      path: '/users/roles',
      lazy: lazyComponent(
        () => import('@pages/client/user/users-roles-page'),
        'UsersRolesPage',
      ),
    },
  ],
};
